import { BookingInventoryFilterOptions } from "../../../features/Booking-Form/typings/booking-inventory-filter-options.types";
import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";

type Options = {
  enabled?: boolean;
};

export function useRemoteFetchBookingInventoryFilterOptions(
  bookingType: BookingType | undefined,
  options?: Options
) {
  return useRemoteQuery<BookingInventoryFilterOptions>({
    queryKey: ["booking-inventory-filter-options", bookingType],
    url: "booking/inventory-filter-options",
    params: bookingType ? { bookingType } : undefined,
    enabled: Boolean(options?.enabled && bookingType)
  });
}
